//added sidechain 
import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
  type: 'analytics',
  eventCategory: 'interaction',
  eventAction: 'click',
  eventLabel: 'etc'
})
//end of sidechain

require("savage-image");
var savage = require("savage-query");

var yes = ["yes", "approved", "maintained", "for"];

var $ = require("./lib/qsa");

var menu = document.querySelector(".menu-burger");
var menuLinks = document.querySelector(".menu-burger .linkHolder");

var hoverMenu = function() {
    menuLinks.classList.add("show");
    menu.classList.remove("unclicked");
    menu.classList.add("clicked");
};

var unhoverMenu = function() {
  menuLinks.classList.remove("show");
  menu.classList.remove("clicked");
  menu.classList.add("unclicked");
};

var clickMenu = function() {
  if (menuLinks.classList.contains('show')) {
    menuLinks.classList.remove("show");
    menu.classList.remove("clicked");
    menu.classList.add("unclicked");
  } else {
    menuLinks.classList.add("show");
    menu.classList.remove("unclicked");
    menu.classList.add("clicked");
  }
};

var screenWidth = Math.max(
    document.documentElement["clientWidth"],
    document.body["scrollWidth"],
    document.documentElement["scrollWidth"],
    document.body["offsetWidth"],
    document.documentElement["offsetWidth"]
);

if (screenWidth > 800) {
  menu.addEventListener("mouseover", hoverMenu);
  menu.addEventListener("mouseleave", unhoverMenu);
} else {
  menu.addEventListener("click", clickMenu);
}

// menu.addEventListener("click", unhoverMenu);
// menu.addEventListener("click", unhoverMenu);

const startMap = window.mapData;

//enable county maps
$("savage-image.county").forEach(function(map, i) {
  var tooltip = document.createElement("div");
  tooltip.classList.add("popup");
  // map.parentElement.appendChild(tooltip);
  map.closest(".county-map").appendChild(tooltip);

  var raceID = map.getAttribute("data-race");
  var data = window.mapData[raceID];
  var lastCounty = null;

  var hover = function(e) {

    var id = this.getAttribute("id").replace(/_/g, " ");
    if (id != lastCounty) {
      var county = data[id] || {};
      var results = county.results || [];
      this.style.stroke = "black";
      this.style.strokeWidth = 3;

      var html = `<span class="county">${id}</span>
      <ul>
      ${results.map(r => {
        return `
        <li>
          <span class="candidate">${r.candidate}</span>
          <span class="spacer"></span>
          <span class="votes">${r.percent ? r.percent.toFixed(1) + "%" : "0.0%"}&nbsp;(${r.votes})</span>`
      }).join("") || "<li> No results yet."}
      </ul>`

      tooltip.innerHTML = html;
    }
    lastCounty = id;
    tooltip.classList.add("show");

    var bounds = map.getBoundingClientRect();
    var x = e.clientX - bounds.left;
    var y = e.clientY - bounds.top;
    if (x > bounds.width >> 1) {
      x -= tooltip.offsetWidth;
    }
    if (y > bounds.height >> 1) {
      y -= tooltip.offsetHeight + 10;
    } else {
      y += 20;
    }

    tooltip.style.left = `${x}px`;
    tooltip.style.top = `${y}px`;
  };

  var exit = function() {
    tooltip.classList.remove("show");
    this.style.stroke = "#E0E0E0";
    this.style.strokeWidth = 2;
  };

  var ready = function() {

    var counties = $(".county", map);
    counties.forEach(function(path) {
      var $path = savage(path);

      var id = path.id.replace(/_/g, " ");
      var result = data[id];

      if (!result) {
        $path.addClass("null");
      } else if (!result.winner) {
        $path.addClass("tie");
      } else if (result.winner.party) {
        if ((result.results[0].party == "D") && (result.results[1].party == "D")) {
          $path.addClass(result.results[0].candidateID === result.winner.candidateID ? "dem" : "demTwo");
        } else {
          $path.addClass(result.winner.party == "D" ? "dem" : "rep");
        }
      } else {
        var option = result.winner.candidate.toLowerCase();
        $path.addClass(yes.indexOf(option) > -1 ? "yes" : "no");
      }

      path.addEventListener("mousemove", hover);
      path.addEventListener("mouseleave", exit);
    });
  }

  map.setAttribute("src", map.getAttribute("data-src"));
  map.addEventListener("load", ready);

});

$("savage-image.district").forEach(function(map, i) {
  var districtID = map.getAttribute("data-district") * 1;

  var ready = function() {
    var paths = $("path, polygon", map);
    paths.forEach(function(p) {
      savage(p).addClass(p.id == districtID ? "highlight" : "null");
    });
  }

  map.setAttribute("src", map.getAttribute("data-src"));
  map.addEventListener("load", ready);

});

var tabCon = document.querySelectorAll('.tab-container');

var onTabClick = function(e) {
  if (e) e.preventDefault();
  var href = this.getAttribute("href");
  $(".tab.active").forEach(active => active.classList.remove("active"));
  $(`.tab[href="${href}"]`).forEach(t => t.classList.add("active"));
  $("section.category.show").forEach(s => s.classList.remove("show"));
  var section = document.querySelector(href);
  section.classList.add("show")
  if (window.history && window.history.replaceState) {
    window.history.replaceState(href, "", href);
  } else {
    window.location.hash = href.replace("#", "section-");
  }

  if (this.closest(".tab-container") === tabCon[1]) {
    // console.log("im bottom");
    getElementOffset();
  }
}

function getElementOffset(){
    var de = document.documentElement;
    var element = tabCon[0]
    var box = element.getBoundingClientRect();
    var top = box.top + window.pageYOffset - de.clientTop;
    var left = box.left + window.pageXOffset - de.clientLeft;
    // console.log(top);
    window.scrollTo(0, top - 70);
}

$(".tab").forEach(t => t.addEventListener("click", onTabClick));


var hash = window.location.hash.replace("section-", "");

 // = window.location.hash.replace("section-", "");

var firstTab = document.querySelector("a.tab");
if (hash) {
  //restore place from the URL hash
  var tab = document.querySelector(`a.tab[href="${hash}"]`);

  onTabClick.call(tab || firstTab);
} else {
  onTabClick.call(firstTab);
}

var closest = function(el, className) {
  while (!el.classList.contains(className) && el !== document.body) el = el.parentElement;
  if (el == document.body) return null;
  return el;
};



var onSubnavChange = function() {
  var val = this.value;
  var section = closest(this, "category");
  var selector = `[data-subcat="${val}"]`;
  var subcats = Array.prototype.slice.call(section.querySelectorAll(".subcategory"));
  var subLinks = section.querySelectorAll("[data-subLink]");
  subLinks.forEach(s => s.classList.remove("show"));
  subcats.forEach(s => s.classList.remove("show"));
  section.querySelector(`[data-subLink="${val}"]`).classList.add("show");
  section.querySelector(selector).classList.add("show");
};

$("select.subnav").forEach(function(s) {
  s.addEventListener("change", onSubnavChange);
  onSubnavChange.call(s);
});

document.body.className = "";

// const url = "https://projects-staging.seattletimes.com/weedy-depressor-2/assets/delegates.json";

// function refresh() {
//   console.log("refresh function is running");

//   fetch(url)
//   .then(function(response) {
//     var dataResponse = response.json();
//     // console.log(dataResponse);
//     // return dataResponse;
//     dataResponse.then(function(result) {
//       var reMap = result.presstatebystatetable.allStates; // "Stuff worked!"
//       readyPresMap(reMap);
//     }, function(err) {
//       console.log(err); // Error: "It broke"
//     });

//   })
//   .catch(function(error) {
//     console.log(error);
//   });

//   setTimeout(refresh,20000);
// };

// refresh();
